import HttpClient from './core.service'
const { get, post, del, put } = HttpClient

export const getConnectionLOg = (payload: any) => get('/admin/connection_log', payload)